import hybridConfig from "lib/HybridConfig";
import { datadogRum } from "@datadog/browser-rum";

// All our explicit calls to third party monitoring services should be wired in here.
class MonitoringController extends Backbone.Controller {

    constructor(...args) {
        super(...args);
        const {
            enabled: ddEnabled,
            userConfiguration: ddUserConfig,
        } = hybridConfig.get("datadog", {});
        if (ddEnabled && ddUserConfig) {
            datadogRum.init({
                sampleRate: 100,
                actionNameAttribute: "data-shortname",
                ...ddUserConfig,
            });
        }
    }

    onAddReleaseVersion(name, version) {
        /* will be overloaded */
    }

    onSetUsername(username) {
        datadogRum.setUser({
            name: username
        });
    }

    onSetActiveOrganization(org) {
        datadogRum.addRumGlobalContext("organization", org);
    }

}

MonitoringController.prototype.events = {
    "monitoring:add:release:version": "onAddReleaseVersion",
    "monitoring:set:username": "onSetUsername",
    "monitoring:set:active:organization": "onSetActiveOrganization"
};

export default MonitoringController;









// WEBPACK FOOTER //
// ./app/controllers/MonitoringController.js